import React from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { Controller, } from "react-hook-form";
import { ErrorMessage } from "./ValidationMessage";
const toIOptions = (opts) => opts.map((o) => ({ label: o.label, value: o.value }));
/**
 * Multi-select with the same Autocomplete + filled TextField look as {@link FSelect}.
 * Uses MUI <code>limitTags={1}</code> so one Chip shows the first label and a "+N" Chip covers the rest.
 */
export function FMultiSelectChips({ name, control, label, options, size = "medium", }) {
    const iOptions = React.useMemo(() => toIOptions(options), [options]);
    return (React.createElement(Controller, { name: name, control: control, render: ({ field, fieldState: { error: fieldError } }) => {
            const selectedValues = (Array.isArray(field.value)
                ? field.value
                : []);
            const selectedOptions = selectedValues
                .map((v) => iOptions.find((o) => String(o.value) === v))
                .filter((o) => o != null);
            return (React.createElement(Box, null,
                React.createElement(Autocomplete, { multiple: true, disableCloseOnSelect: true, limitTags: 1, options: iOptions, value: selectedOptions, onBlur: field.onBlur, onChange: (_, newValue) => {
                        field.onChange(newValue.map((o) => String(o.value)));
                    }, getOptionLabel: (option) => option.label, isOptionEqualToValue: (a, b) => String(a.value) === String(b.value), renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { name: field.name, inputRef: field.ref, label: label, error: !!fieldError, fullWidth: true, size: size, variant: "filled" }))) }),
                React.createElement(ErrorMessage, { error: fieldError === null || fieldError === void 0 ? void 0 : fieldError.message })));
        } }));
}
